import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import LabReport from "../models/LabReport";
function LabRepView() {
    
    return (
        <>
        <LabReport/>
        </>
    );
}

export default LabRepView;
